import {$http, Constants} from '@/store/actions/constants';

const url = `${Constants.BaseURL}/calendar`;

export const CalendarActions = {

    info({commit, state}, forceQuery) {
        if (forceQuery || state.calendar.info.list.length === 0) {
            return $http.get(`${url}/info`, state.authHeader).then(r => {
                if (r.status === 200) {
                    let info = {
                        status: r.data.status,
                        list: r.data.info
                    };
                    commit("SET_CALENDAR_INFO", info);
                }
            }).catch((e) => console.error("calendar info error :", e));
        }
    },

    search({commit, state}, search) {
        return $http.get(`${url}/search`, {
            ...state.authHeader,
            params: search,
        }).then(r => {
            if (r.status === 200) {
                let data = {
                    today: r.data.start_date,
                    events: r.data.events,
                };
                commit('SET_CALENDAR_EVENTS', data);
            }
        }).catch((e) => {
            console.error('calendar search error :', e);
        });
    },

    sync({dispatch, commit, state}, data) {
        let payload = {
            action: "Sync",
            country_code: data.country_code,
            country_name: data.country_name,
            year: new Date().getFullYear(),
        };
        return $http.post(`${url}/sync`, payload, state.authHeader).then(r => {
            if (r.status === 200) {
                dispatch("calendarInfo", true);
                dispatch("calendarSearch", {index: 0});
            }
        }).catch(e => console.log("calendar sync error :", e));
    },

    unsync({dispatch, commit, state}, data) {
        let payload = {
            action: 'UnSync',
            country_code: data.country_code,
            country_name: data.country_name,
        };
        return $http.post(`${url}/unsync`, payload, state.authHeader).then(r => {
            if (r.status === 200) {
                dispatch('calendarInfo', true);
                dispatch('calendarSearch', {index: 0});
            }
        }).catch(e => console.error('calendar unsync error :', e));
    },

    preview({commit, state}, code) {
        return $http.get(`${url}/preview/${code}`, state.authHeader);
    },

    updateEntry({commit, state}, payload) {
        return $http.put(`${url}/entry/${payload.id}`, payload.data, state.authHeader);
    },

    deleteEntry({commit, state}, id) {
        return $http.delete(`${url}/entry/${id}`, state.authHeader);
    },
    addEntry({commit, state}, data) {
        return $http.post(`${url}/entry`, data, state.authHeader);
    },
};